import _ from 'underscore';
import PageableCollection from 'backbone.paginator';


/** Provides some helper methods and default values for the pageable
* collection.
*/
var PagColProto = PageableCollection.prototype;

module.exports = PageableCollection.extend({
  mode: 'server',

  /* We don't need to send this information to the server
  */
  queryParams: {
    totalRecords: null,
    totalPages: null
  },

  state: {
    pageSize: 20,
    pagesInRange: 10
  },

  pageSet() {
    if (!this._multiplePages()) {
      return [];
    }

    var middle = this.state.currentPage;
    if (middle <= this.state.pagesInRange) {
      middle = 11;
    }

    var max = middle + this.state.pagesInRange;
    if (max > this.state.totalPages) {
      max = this.state.totalPages;
    }

    var pages =_.range(
      middle - this.state.pagesInRange, max);
    return pages;
  },

  parseRecords: response => _.isArray(response) ? response : response.results,

  parseState(response) {
    var rtnState = {
      totalRecords: response.count,
      totalPages: response.page_count
    };

    if (response.per_page) {
      rtnState.pageSize = response.per_page;
    }

    return rtnState;
  },

  url() {
    return this.urlBase;
  },

  initialize(models, options = {}) {
    this.options = options;
    this.urlBase = options.urlBase || this.urlBase;
    this.search_params = options.search_params || {};
  },

  /** Override the backbone paginator's fetch to always set search_params,
  * always reset and use the proper jQuery calls
  */
  fetch(options = {}) {
    let data = options.data || {};
    data = _.extend(data, this.search_params);
    options.data = data;
    options.traditional = true;
    this.state.loading = true;
    this.trigger('state');
    PagColProto.fetch.call(this, options).always(() => {
      this.state.loading = false;
      this.trigger('state');
    });
  },

  /** Clears the form.
  */
  clearForm() {
    this.search_params = {};

    this.fetch();
    return this;
  },

  /** Handle cases of an initial empty state.
  */
  _multiplePages() {
    if (this.state.totalPages) {
      return this.state.totalPages > 1;
    }
    return false;
  },

  /**
   * Instruct the server to restrict collection based on category filters.
   */
  categoryFilter(categoryFilterTerms) {
    _.extend(this.search_params, categoryFilterTerms);
    this.fetch();
    return this;
  },

  /** Run a search against the API.
  */
  search(term) {
    if (term) {
      this.search_params.filter = term;
    }
    else {
      delete this.search_params.filter;
    }

    this.fetch();
    return this;
  }
});



// WEBPACK FOOTER //
// ./base/collections/page.js